import { usePhoneCampaign } from '@hc-frontend/core-ui';
import { Link } from '@hc-frontend/core-ui';

export default function TalkAgent() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <Link
        data-call-call-type={phoneCampaign.callType}
        data-call-placement={phoneCampaign.placement}
        data-call-product={phoneCampaign.product}
        data-call-phone={phoneCampaign.href}
        data-call-advertiser={phoneCampaign.advertiser}
        className="flex py-16-16 justify-center rounded-full border border-solid border-[#FFB929] bg-[#FFB929] text-[#000] max-w-full font-bold text-base md:text-xl"
        href={phoneCampaign.href}
        id="call_now_button"
      >
        Talk to a Licensed Agent
      </Link>
    );
  }

  return null;
}
